import React, { ReactNode } from 'react'
// import PropTypes from 'prop-types'
import { Translate } from 'utils/localize'
import { getLanguage } from 'lib/language/selectors'
import { formatDistanceStrict } from 'date-fns'
import { fr, de, ru, ja } from 'date-fns/locale'
import { useSelector } from 'react-redux'
// import ReactTooltip from 'react-tooltip'
import { GlobalState } from 'types'
import HexagonFilled from '../../../../../../../recruit-shared/components/hexagon-filled'
import style from './Achievement.module.scss'

const locales = { fr, de, ru, ja }

interface Props {
    count: number
    tooltip: ReactNode
    achieved: boolean
    date?: string
}

const Achievement = ({
    count,
    // tooltip,
    achieved,
    date,
}: Props): JSX.Element => {
    const language = useSelector((state: GlobalState) => getLanguage(state))
    let formattedDate
    if (date) {
        // const test = '2018-07-09T15:40:26'
        const dateString = date.substr(0, date.indexOf('.'))
        const dateObject = new Date(dateString)
        formattedDate = formatDistanceStrict(new Date(dateObject), new Date(), {
            addSuffix: true,
            locale: locales[language],
        })
    }

    return (
        <div className={style.achievement} data-tip data-for={`tip${count}`}>
            <div className={style.hexagon}>
                {achieved ? (
                    <HexagonFilled red>{count}</HexagonFilled>
                ) : (
                    <HexagonFilled gray>
                        <span className={style.gray}>{count}</span>
                    </HexagonFilled>
                )}
            </div>
            <div className={style.content}>
                {count === 1 ? (
                    <p className={style.title}>
                        <Translate id="recruit.recruitText">Recruit</Translate>
                    </p>
                ) : (
                    <p className={style.title}>
                        <Translate id="recruit.recruitsText">
                            Recruits
                        </Translate>
                    </p>
                )}
                {date && (
                    <p className={style.text}>
                        <Translate id="recruit.achievementReached">
                            Achievement reached{' '}
                        </Translate>{' '}
                        {formattedDate}
                    </p>
                )}
            </div>
            {/* <ReactTooltip
              className={achieved ? style.activetip : style.inactivetip}
              id={`tip${count}`}
              effect="solid"
              aria-haspopup="true">
                {tooltip}
            </ReactTooltip> */}
        </div>
    )
}

Achievement.defaultProps = {
    date: '',
}

// Achievement.propTypes = {
//     achieved: PropTypes.bool,
//     count: PropTypes.number.isRequired,
//     date: PropTypes.string,
//     tooltip: PropTypes.string,
// }

export default Achievement
